import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useSearchParams } from 'react-router';
import { SitePageShell } from '@/shared/ui';
import { PortfolioList } from '@/widgets/portfolio-list';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/**
 * 포트폴리오(/portfolio) — 카테고리·페이지는 URL 파라미터가 단일 원천이다.
 * 기획전·스토어와 같은 디자인 언어 — 큰 "Portfolio" 제목·설명, 밑줄 카테고리 탭, 각진 사진 칸의 편집형 카드.
 */
export const PortfolioPage = (): ReactElement => {
  const [params] = useSearchParams();
  const category = params.get('category');
  const parsedCategory = normalizedUuidSchema.safeParse(category);
  const requestedPage = params.get('page');
  const number = requestedPage === null ? 1 : Number(requestedPage);
  const validPage =
    requestedPage === null || (/^[1-9]\d*$/.test(requestedPage) && Number.isSafeInteger(number));
  return (
    <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
      <header className="mb-10 flex flex-col gap-4 sm:mb-14">
        {/* 보이는 제목은 영문 "Portfolio" 한 단어, 보조기기에는 한국어 화면 이름을 함께 읽힌다. */}
        <h1 className="text-[clamp(2.5rem,5vw,4.5rem)] leading-none font-bold tracking-[-0.03em]">
          <span aria-hidden>Portfolio</span>
          <span className="sr-only">포트폴리오</span>
        </h1>
        <p className="text-[15px] text-muted-foreground sm:text-base">
          다양한 기업·단체와 함께 만든 제작 사례를 살펴보세요.
        </p>
      </header>
      <PortfolioList
        categoryId={parsedCategory.success ? parsedCategory.data : undefined}
        page={validPage ? number : 1}
        invalidCategory={category !== null && !parsedCategory.success}
        invalidPage={!validPage}
      />
    </SitePageShell>
  );
};
